import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowRight, MessageSquare, CheckCircle2 } from 'lucide-react';
import toast from 'react-hot-toast';
import { authAPI } from '../api';

const getTheme = () => localStorage.getItem('theme') || 'light';

const ForgotPassword = () => {
  const theme = getTheme();
  const isDark = theme === 'dark';
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authAPI.forgotPassword(email);
      setSent(true);
    } catch (err) {
      // USER_NOT_FOUND still shows the same "check your email" success
      // state as a real send, not an error — telling a requester whether
      // an email exists in the system is a user-enumeration leak.
      if (err?.response?.data?.code === 'USER_NOT_FOUND') {
        setSent(true);
      } else {
        toast.error('تعذّر إرسال رابط الاستعادة. حاول مرة أخرى.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-bg min-h-[100dvh] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/welcome" className="inline-flex items-center gap-3 group">
            <div className="w-14 h-14 rounded-2xl bg-ink flex items-center justify-center shadow-lg shadow-teal-500/30 group-hover:shadow-teal-500/50 transition-shadow duration-300">
              <MessageSquare className="w-7 h-7 text-white" />
            </div>
            <span className="text-3xl font-bold gradient-text">هندل</span>
          </Link>
          <h1 className={`text-2xl font-bold mt-6 mb-2 ${isDark ? 'text-white' : 'text-slate-900'}`}>
            استعادة كلمة المرور
          </h1>
          <p className={isDark ? 'text-slate-400' : 'text-slate-500'}>
            هنبعتلك رابط لإعادة تعيين كلمة المرور على بريدك الإلكتروني
          </p>
        </div>

        <div className="auth-card">
          {sent ? (
            <div className="text-center py-4">
              <div className="w-14 h-14 rounded-full bg-emerald-50 border border-emerald-200 flex items-center justify-center mx-auto mb-4">
                <CheckCircle2 className="w-7 h-7 text-emerald-600" />
              </div>
              <p className={`font-medium mb-1 ${isDark ? 'text-white' : 'text-slate-900'}`}>
                تحقق من بريدك الإلكتروني
              </p>
              <p className={`text-sm ${isDark ? 'text-slate-400' : 'text-slate-500'}`}>
                لو الإيميل ده مسجل عندنا، هيوصلك رابط استعادة كلمة المرور خلال دقائق.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className={`block text-sm font-medium mb-1.5 ${isDark ? 'text-slate-300' : 'text-slate-700'}`}>
                  البريد الإلكتروني
                </label>
                <div className="relative">
                  <Mail className={`absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 ${isDark ? 'text-slate-500' : 'text-slate-400'}`} />
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="input-glass pr-10"
                    placeholder="name@example.com"
                    dir="ltr"
                    required
                  />
                </div>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="btn-auth flex items-center justify-center gap-2"
              >
                {loading ? (
                  <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white"></div>
                ) : (
                  <>
                    <span>إرسال رابط الاستعادة</span>
                    <ArrowRight className="w-5 h-5" />
                  </>
                )}
              </button>
            </form>
          )}
        </div>

        <p className={`text-center text-sm mt-6 ${isDark ? 'text-slate-400' : 'text-slate-500'}`}>
          تذكرت كلمة المرور؟{' '}
          <Link to="/login" className="text-ink dark:text-slate-100 font-medium hover:underline">
            سجل دخولك
          </Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
